<svelte:options accessors/>
<script lang="ts">
    import {onMount} from "svelte";
    import Dialog, {Actions, Content, Title} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    let open = false;
    export let title;
    export let messages: Array<any>;

    onMount(() => {
        if (messages.length > 0) {
            open = true;
        }
    });
</script>

<Dialog bind:open>
    <Title>{title}</Title>
    <Content>
        {#each messages as message}
        <div class="box-l">
            {message}
        </div>
        {/each}
    </Content>
    <Actions>
        <NauiButton caption="Aceptar" color="accent" mode="solid" on:click={() => {open = false;}}/>
    </Actions>
</Dialog>
